import React, { useId } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import SmsConsentText from "../SmsConsentText";
import useAddMobileStep from "./useAddMobileStep";
import "./security.css";

// Presentational: the "add a mobile" step shown right after a confirmed setup (docs/specs/authenticator-mfa-sms-enroll.md §3).
export const AddMobileStepView = ({ mobile, setMobile, agreed, setAgreed, error, busy, save, skip }) => {
  const titleId = useId();
  return (
    <Modal show animation={false} backdrop="static" aria-labelledby={titleId} className="mfa-modal">
      <Modal.Header>
        <Modal.Title id={titleId}>Get security alerts by text</Modal.Title>
        <span className="mfa-modal-sub">We&apos;ll text you if someone changes how you sign in.</span>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="mfa-add-mobile">
          <Form.Label>Mobile number</Form.Label>
          <Form.Control
            type="tel"
            inputMode="tel"
            autoComplete="tel-national"
            placeholder="(702) 123-4567"
            value={mobile}
            disabled={busy}
            isInvalid={Boolean(error)}
            onChange={(event) => setMobile(event.target.value)}
          />
        </Form.Group>
        {error && <div className="alert alert-danger mt-2 mb-0" role="alert">{error}</div>}
        <Form.Check
          id="mfa-add-mobile-consent"
          className="small text-muted mt-3"
          checked={agreed}
          disabled={busy}
          onChange={(event) => setAgreed(event.target.checked)}
          label={<SmsConsentText />}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" className="mfa-btn-quiet" type="button" disabled={busy} onClick={skip}>
          Skip for now
        </Button>
        <Button type="button" className="text-white fw-bold" disabled={busy || !agreed} onClick={save}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

const AddMobileStep = ({ token, onDone }) => <AddMobileStepView {...useAddMobileStep({ token, onDone })} />;

export default AddMobileStep;
